module.exports = __webpack_public_path__ + "static/media/Expansion of dental arches4.a0dac35d.png";